import { Center, Loader } from '@mantine/core';

export const LoadingSpinner = () => {
  return (
    <Center p="xl" data-testid="loading-spinner">
      <Loader size="lg" />
    </Center>
  );
};
